import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";

function Frame({ children }) {
  return <div className="min-h-screen bg-[#FAF7F2] grid place-items-center px-5"><div className="pl-card p-8 max-w-md w-full text-center space-y-4"><div className="flex justify-center"><Logo /></div>{children}</div></div>;
}

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setState("paid");
      } catch (e) { /* retry */ }
      if (++tries < 10) timer = setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
    return () => clearTimeout(timer);
  }, [params]);
  return (
    <Frame>
      <h1 className="font-heading text-3xl font-extrabold" data-testid="payment-status-title">
        {state === "paid" ? "You're all set!" : state === "pending" ? "Payment processing" : "Confirming payment..."}
      </h1>
      <p className="text-slate-600">{state === "paid" ? "Thanks for subscribing. Every pet, every caregiver, one price." : state === "pending" ? "This can take a minute. Your plan will update automatically." : "Hang tight a few seconds."}</p>
      <Link to="/app" className="pl-btn-primary w-full" data-testid="payment-continue-btn">Back to today</Link>
    </Frame>
  );
}

export function PaymentCancel() {
  return (
    <Frame>
      <h1 className="font-heading text-3xl font-extrabold">Checkout canceled</h1>
      <p className="text-slate-600">No charge was made. You can subscribe anytime from Settings.</p>
      <Link to="/app/settings#billing" className="pl-btn-primary w-full" data-testid="payment-back-settings-btn">Back to settings</Link>
    </Frame>
  );
}
